module.exports = __webpack_public_path__ + "img/sensira.65245294.png";